const { REACT_APP__WEBSITE_TYPE, REACT_APP__BRANCH } = process.env;

export const isEspagne = REACT_APP__WEBSITE_TYPE === 'es';
export const isFrance = REACT_APP__WEBSITE_TYPE === 'fr';

export const isProdOrPreProd = ['prod-es', 'prod-fr', 'preprod-es', 'preprod-fr'].includes(REACT_APP__BRANCH);
